<h1 matDialogTitle>Add Note</h1>

<mat-dialog-content>

  <form class="dynamic-form" [formGroup]="form" style="width: 100%">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Note *</mat-label>
        <textarea #note matInput rows="2" style="text-align: left;" type="text" minlength="1" maxlength="200" formControlName="salesOrderNoteText" autocomplete="new-password"></textarea>
        <mat-hint align="end">{{note.value.length}} / 200</mat-hint>
      </mat-form-field>

      <mat-checkbox fxFlex="100" formControlName="addToDoList" value="" color="primary" (change)="addToDoListChange($event)">Add to To-Do list</mat-checkbox>

      <mat-form-field *ngIf="form.value.addToDoList" [fxFlex]="100">
        <mat-label>Type</mat-label>
        <mat-select formControlName="toDoListItemTypeId">
          <mat-option *ngFor="let action of config?.toDoListItemTypes" [value]="action.id">
            {{action.display}}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!form.valid" (click)="save()">Add Note</button>
</mat-dialog-actions>
